import { WORKBENCH_CONFIG } from "@/app/workbench-config";
import { Panel } from "@/components/panel";
import { WorkbenchActionCard } from "@/components/workbench-action-card";

export function WorkbenchPage({ routeKey }: { routeKey: string }) {
  const config = WORKBENCH_CONFIG[routeKey];

  if (!config) {
    return (
      <Panel
        title="Module Unconfigured"
        description="This route has no workbench configuration yet."
      >
        <p className="text-sm text-muted">
          Add a definition in <code>src/app/workbench-config.ts</code> to wire this page.
        </p>
      </Panel>
    );
  }

  return (
    <div className="space-y-4 md:space-y-6">
      <Panel title={config.title} description={config.description}>
        <p className="text-sm text-muted">
          Each card executes against live backend endpoints with cookie-auth and same-origin
          routing preserved.
        </p>
      </Panel>

      <div className="grid gap-3 md:gap-4 grid-cols-1 lg:grid-cols-2">
        {config.actions.map((action) => (
          <WorkbenchActionCard key={action.id} action={action} />
        ))}
      </div>
    </div>
  );
}
